/**
 * Vite build-time env access, isolated in its own module.
 *
 * `import.meta.env` is a Vite construct that only exists in the browser bundle;
 * it cannot execute under the CommonJS test runtime. Keeping the single reference
 * here lets Jest map this module to a stub (`testing/env-stub.ts`) while Vite
 * still statically inlines `VITE_SERVER_URL` for the real build. Consumers import
 * {@link readServerUrl} instead of touching `import.meta` directly.
 */

export function readServerUrl(): string | undefined {
  return import.meta.env.VITE_SERVER_URL;
}

/**
 * Deployment mode selector. `prod` routes the app at the co-located control plane
 * (`/api/*`, same-origin behind CloudFront — M5); anything else (default) uses the
 * local dev endpoints (`/dev/*`). Set via `VITE_DEPLOY_MODE=prod` at build time.
 */
export function readDeployMode(): string | undefined {
  return import.meta.env.VITE_DEPLOY_MODE;
}
